const feedback = {
  'Activity': 'Actividad',
  'Enjoying the MedEffects App?': '¿Le gusta la aplicación MedEffects?',
  'Yes, I am': 'Sí, me gusta',
  'Could be better': 'Podría mejorar',
  'Could not save your feedback. Please retry.': 'No se pudo guardar su opinión. Inténtelo de nuevo.',
  'Feedback': 'Opiniones',
  'All-time feedback. Percentages include thumbs-up and thumbs-down responses only.': 'Opiniones de todo el período. Los porcentajes incluyen solo respuestas positivas y negativas.',
  'Loading feedback...': 'Cargando opiniones...',
  'Could not load feedback. Please retry.': 'No se pudieron cargar las opiniones. Inténtelo de nuevo.',
  'Thumbs up': 'Positiva',
  'Thumbs down': 'Negativa',
  'Total responses': 'Total de respuestas',
  'Dismissed': 'Cerradas sin responder',
  'No feedback responses yet.': 'Aún no hay respuestas.',
  'Response': 'Respuesta',
};

export default feedback;
